var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"quick-add-button",class:[
    { 'quick-add-button--sizes-shown': _vm.sizesAreShown },
    _vm.modifier ? ("quick-add-button--" + _vm.modifier) : '' ]},[(_vm.isIconVisible)?_c('span',{staticClass:"quick-add-button__plus icon-plus"}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }